





























































































































import {cloneDeep} from 'lodash';
import {Chart} from 'highcharts-vue';
import {Component, Vue} from 'vue-property-decorator';
import IconButton from '@c/controls/IconButton.vue';
import Breadcrumbs from '@c/controls/Breadcrumbs.vue';
import Loading from '@c/controls/Loading.vue';
import {Can} from '@casl/vue';
import {OilNodeData, OilNodeMeasurement, OilNodeTableHeader} from './interfaces';
import oilModule from '@/store/modules/entities/oilModule';
import oilReportModule from '@/store/modules/entities/oilReportModule';
import nodeModule from '@/store/modules/entities/nodeModule';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {NodeData} from '@/system/nodes/interfaces';
import {nodeStatusColorScheme} from '@/components/system/configurate';
import {signalColorScheme} from '@/utils/colorSchemes';
import {httpClient} from '@/api/baseApi';
import router from '@/router';

@Component({
  components: {
    highchart: Chart,
    Breadcrumbs,
    IconButton,
    Loading,
    Can,
  },
})
export default class OilReport extends Vue {
  loadingTree = true;
  errorTree = false;

  oilAnalysis: any[] = [];
  headers: OilNodeTableHeader[] = [];
  chartData: any = {};
  tickPositions: number[] = [];

  oilNode: OilNodeData = {nodeId: 0, measurements: []};
  nodesPath: NodeData[] = [];
  nodeItems: NodeData[] = [];

  getPathByNodeId(id: number): NodeData[] {
    const stack = [...this.nodeItems];
    const prev: Record<string, NodeData> = {};
    while (stack.length) {
      const x = stack.pop();
      if (x && x.id == id) {
        const path: NodeData[] = [];
        let node = x;
        path.push(node);
        while (prev[node.id ? node.id : 0]) {
          node = prev[node.id ? node.id : 0];
          path.push(node);
        }
        path.reverse();
        return path;
      }
      if (x && x.children)
        x.children.forEach(c => {
          if (c.id) {
            prev[c.id] = x;
            stack.push(c);
          }
        });
    }
    return [];
  }

  checkCorrectLevelNode = (parentType: number, node: NodeData) => node.type < parentType;

  checkChildren(item: NodeData) {
    if (item.children && item.children.length) {
      item.children.forEach(node => {
        if (item.children && item.children.length) {
          if (this.checkCorrectLevelNode(item.type, node)) {
            node.leveTypeError = true;
          }
          node.parent = {name: item.name, type: item.type};
          this.checkChildren(node);
        }
        return;
      });
    }
  }

  oId!: number;

  isActiveChart(alias: string) {
    return this.chartData[alias]?.isEnabled == true;
  }

  toggleChart(alias: string) {
    this.chartData[alias].isEnabled = !this.chartData[alias]?.isEnabled;
    this.$nextTick(() => {
      const chartComponent = this.$refs.chart as any;
      if (chartComponent && chartComponent.chart) {
        chartComponent.chart.update(this.getChartOptions());
        this.$forceUpdate();
      }
    });
  }

  async updateReportsTable() {
    const initialHeaders: OilNodeTableHeader[] = [
      {text: '', value: 'col1', sortable: false},
      {text: '', value: 'col2', sortable: false},
    ];
    const templateOilAnalysis: any = [
      {alias: 'oil_type', col1: 'Тип масла', col2: ''},
      /* {alias: 'sample_id', col1: 'Идентификатор образца', col2: ''}, */
      {alias: 'reportType', col1: 'Тип отчета', col2: ''},
      {alias: 'samplingDate', col1: 'Дата отбора', col2: ''},
      {alias: 'receptionDate', col1: 'Дата получения', col2: ''},
      {alias: 'reportDate', col1: 'Дата выдачи заключения', col2: ''},
      {alias: 'machine_hour', col1: 'Моточасы, ч', col2: ''},
      {alias: 'oil_hour', col1: 'Срок службы масла, ч', col2: ''},
      {alias: 'append_oil', col1: 'Долив масла, л', col2: ''},
      {isGroupHeader: true, title: 'Заключение диагноста:'},
      {alias: 'expert_report', col1: '   '},
      {isGroupHeader: true, title: 'Индикаторы износа'},
      {alias: 'al_pa', col1: '    Алюминий, ppm', col2: '', chartBtn: true},
      {alias: 'fe_pa', col1: '    Железо, ppm', col2: '', chartBtn: true},
      {alias: 'cr_pa', col1: '    Хром, ppm', col2: '', chartBtn: true},
      {alias: 'cu_pa', col1: '    Медь, ppm', col2: '', chartBtn: true},
      {alias: 'pb_pa', col1: '    Свинец, ppm', col2: '', chartBtn: true},
      {alias: 'sn_pa', col1: '    Олово, ppm', col2: '', chartBtn: true},
      {alias: 'ag_pa', col1: '    Серебро, ppm', col2: '', chartBtn: true},
      {alias: 'ni_pa', col1: '    Никель, ppm', col2: '', chartBtn: true},
      {alias: 'mn_pa', col1: '    Марганец, ppm', col2: '', chartBtn: true},
      {isGroupHeader: true, title: 'Загрязнение'},
      {alias: 'nap_pr', col1: '    Количество частиц', col2: ''},
      {alias: 'nap4_pr', col1: '    Количество частиц размером > 4 мкм', col2: '', chartBtn: true},
      {alias: 'nap6_pr', col1: '    Количество частиц размером > 6 мкм', col2: '', chartBtn: true},
      {
        alias: 'nap14_pr',
        col1: '    Количество частиц размером > 14 мкм',
        col2: '',
        chartBtn: true,
      },
      {alias: 'water_fl', col1: '    Содержание воды, %', col2: '', chartBtn: true},
      {alias: 'k_pr', col1: '    Калий, ppm', col2: '', chartBtn: true},
      {alias: 'na_pr', col1: '    Натрий, ppm', col2: '', chartBtn: true},
      {alias: 'si_pr', col1: '    Кремний, ppm', col2: '', chartBtn: true},
      {alias: 'ti_pr', col1: '    Титан, ppm', col2: '', chartBtn: true},
      {alias: 'v_pr', col1: '    Ванадий, ppm', col2: '', chartBtn: true},
      {isGroupHeader: true, title: 'Состояние масла'},
      {alias: 'kv40_pr', col1: '    Вязкость при 40°C, сСт', col2: '', chartBtn: true},
      {alias: 'kv100_pr', col1: '    Вязкость при 100°C, сСт', col2: '', chartBtn: true},
      {alias: 'tan_pr', col1: '    Общее кислотное число, мгKOH/г', col2: '', chartBtn: true},
      {alias: 'tbn_pr', col1: '    Общее щелочное число, мгKOH/г', col2: '', chartBtn: true},
      {isGroupHeader: true, title: 'Присадки'},
      {alias: 'p_ad', col1: '    Фосфор, ppm', col2: '', chartBtn: true},
      {alias: 'zn_ad', col1: '    Цинк, ppm', col2: '', chartBtn: true},
      {alias: 'ca_ad', col1: '    Кальций, ppm', col2: '', chartBtn: true},
      {alias: 'ba_ad', col1: '    Барий, ppm', col2: '', chartBtn: true},
      {alias: 'mg_ad', col1: '    Магний, ppm', col2: '', chartBtn: true},
      {alias: 'mo_ad', col1: '    Молибден, ppm', col2: '', chartBtn: true},
      {alias: 'b_ad', col1: '    Бор, ppm', col2: '', chartBtn: true},
      {isButtonLine: true, col1: ' ', col2: ' '},
    ];

    const ORM = oilReportModule;
    ORM.setOid(+this.$router.currentRoute.params.oid);
    await ORM.fetchAll();
    const items = ORM.all.sort((a, b) => a.sampling_ts - b.sampling_ts).slice(-5);
    this.headers = [...initialHeaders];
    this.oilAnalysis = [...templateOilAnalysis];
    this.chartData = {};
    this.tickPositions = [];

    items.forEach((report: any, index: number) => {
      this.headers.push({
        id: report.id,
        report_file: report.report_file,
        text: report.sample_id,
        value: `data${index}`,
        sortable: false,
      });
      this.tickPositions.push(report.sampling_ts);
      Object.keys(report).forEach(key => {
        const idx = this.oilAnalysis.findIndex((row: any) => row.alias == key);
        if (idx >= 0) this.oilAnalysis[idx][`data${index}`] = report[key];
        const idx_mm = this.oilAnalysis.findIndex((row: any) => `${row.alias}_mm` == key);
        if (idx_mm >= 0) this.oilAnalysis[idx_mm]['col2'] = report[key];
        if (report[key] != null && !isNaN(Number(report[key]))) {
          if (this.chartData[key] == undefined) this.chartData[key] = {isEnabled: false, data: []};
          this.chartData[key].data.push({x: report.sampling_ts, y: Number(report[key])});
          const bndr = this.oilNode.measurements.find(m => m.alias == key);
          if (bndr) {
            const color = this.getColorCell(report[key], bndr);
            if (color) {
              this.oilAnalysis[idx][`color-data${index}`] = color;
              this.chartData[key].isEnabled = true;
            }
          }
        }
      });
      if (report.kv_pr_mm) {
        if (report.kv40_pr) {
          const idx = this.oilAnalysis.findIndex((row: any) => row.alias == 'kv40_pr');
          if (idx >= 0) this.oilAnalysis[idx]['col2'] = report.kv_pr_mm;
        }
        if (report.kv100_pr) {
          const idx = this.oilAnalysis.findIndex((row: any) => row.alias == 'kv100_pr');
          if (idx >= 0) this.oilAnalysis[idx]['col2'] = report.kv_pr_mm;
        }
      }
      if (report.expert_report) {
        const idx = this.oilAnalysis.findIndex((row: any) => row.alias == 'expert_report');
        if (idx >= 0)
          this.oilAnalysis[idx] = {
            alias: 'expert_report',
            col1: `${report.expert_report} (${report.laboratory}, ${report.reportDate})`,
          };
      }
    });
    this.headers.push({
      text: '',
      value: 'chartBtn',
      sortable: false,
    });
  }

  async created() {
    this.oId = +this.$router.currentRoute.params.oid;
    await oilModule.fetchAll();
    await nodeModule.fetchAll();
    await measurementsStoreModule.fetchAll();
    try {
      const temp = cloneDeep(nodeModule.all);
      temp.forEach(item => {
        this.checkChildren(item);
      });
      this.nodeItems = temp;
    } catch {
      this.errorTree = true;
    }
    if (this.oId) {
      const {data} = await oilModule.edit(this.oId);
      data.measurements.forEach(m => {
        const meas = measurementsStoreModule.entities.find(e => e.id == m.id);
        if (meas) m.alias = meas.alias;
      });
      this.oilNode = data;
      this.nodesPath = this.getPathByNodeId(+this.oilNode?.nodeId);

      await this.updateReportsTable();
    } else {
      this.errorTree = true;
    }
    this.loadingTree = false;
  }

  getColorCell(value: number, bndr: OilNodeMeasurement) {
    if (bndr.topErrorBoundary != null && value > bndr.topErrorBoundary)
      return nodeStatusColorScheme.topErrorBoundary;

    if (bndr.bottomErrorBoundary != null && value < bndr.bottomErrorBoundary)
      return nodeStatusColorScheme.bottomErrorBoundary;

    if (
      bndr.topDangerBoundary != null &&
      bndr.topErrorBoundary != null &&
      value > bndr.topDangerBoundary &&
      value <= bndr.topErrorBoundary
    )
      return nodeStatusColorScheme.topDangerBoundary;

    if (
      bndr.topWarningBoundary != null &&
      bndr.topDangerBoundary != null &&
      value > bndr.topWarningBoundary &&
      value <= bndr.topDangerBoundary
    )
      return nodeStatusColorScheme.topWarningBoundary;

    if (
      bndr.bottomDangerBoundary != null &&
      bndr.bottomWarningBoundary != null &&
      value > bndr.bottomDangerBoundary &&
      value <= bndr.bottomWarningBoundary
    )
      return nodeStatusColorScheme.bottomWarningBoundary;

    if (
      bndr.bottomErrorBoundary != null &&
      bndr.bottomDangerBoundary != null &&
      value > bndr.bottomErrorBoundary &&
      value <= bndr.bottomDangerBoundary
    )
      return nodeStatusColorScheme.bottomDangerBoundary;

    return '';
  }

  onChangeNode(item: NodeData) {
    router.push(`/nodes/${item.id}`);
  }

  openEditOil() {
    router.push(`/oil/${this.oId}`);
  }

  openAdminOil() {
    router.push(`/oil/${this.oId}/admin`);
  }

  async viewPDF(header: any) {
    try {
      const {data} = await httpClient.get(`/oil-nodes/${this.oId}/reports/${header.id}/download`, {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(data);
      window.open(url, '_blank');
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 1000);
    } catch (error) {
      console.error('Ошибка при загрузке PDF:', error);
      this.$emit('error', 'Не удалось загрузить PDF документ');
    }
  }

  getChartOptions() {
    const series: any[] = [];
    const yAxis: any[] = [];
    let idx = 0;

    Object.keys(this.chartData).forEach(key => {
      const elem = this.oilAnalysis.find((row: any) => row.alias == key);
      if (elem && this.chartData[key].isEnabled) {
        series.push({
          id: `chart-${idx}`,
          name: elem.col1,
          data: this.chartData[key].data,
          visible: true,
          type: 'line',
          color: signalColorScheme[idx % signalColorScheme.length].mainColor,
          yAxis: idx,
        });
        yAxis.push({title: undefined, visible: false});
        idx++;
      }
    });

    const tp = new Set(this.tickPositions);
    this.tickPositions.forEach(ts => {
      tp.add(Date.UTC(new Date(ts).getUTCFullYear(), 0, 1));
    });
    tp.add(Date.UTC(new Date(Math.max(...this.tickPositions)).getUTCFullYear() + 1, 0, 1));
    const _tp = [...tp].sort();

    return {
      credits: {
        enabled: false,
      },
      title: '',
      xAxis: {
        gridLineWidth: 1,
        title: {
          text: 'Дата',
        },
        tickPositions: _tp,
        type: 'datetime',
        labels: {
          format: '{value:%d.%m.%Y}', // Формат отображения дат
          rotation: -90, // Поворот меток для удобства чтения
          style: {
            fontSize: '10px',
          },
          step: 1,
        },
        softMin: _tp[0],
        softMax: _tp[_tp.length - 1],
      },
      yAxis: yAxis,
      //графики
      series,
      navigation: {
        buttonOptions: {
          enabled: false,
        },
      },
      plotOptions: {
        series: {
          states: {
            //отключает выделение точки на графике
            hover: {
              enabled: false,
              halo: {
                size: 0,
              },
              inactive: {
                enabled: false,
              },
            },
          },
          events: {
            legendItemClick: function() {
              return false;
            },
            //            hide: function(e: any) {
            //              that.showOrHide(e);
            //            },
            //            show: function(e: any) {
            //              that.showOrHide(e);
            //            },
          },
        },
        line: {
          turboThreshold: 0,
          boostThreshold: 0,
          marker: {
            enabled: false,
            radius: 0,
          },
          states: {
            inactive: {
              opacity: 1,
            },
          },
        },
      },
      chart: {
        animation: false, //общая анимация включена - расскоментировать, чтобы отключить
        //        events: {
        //          selection: this.onSelection,
        //          render: this.onRender,
        //          afterUpdate: this.afterUpdate,
        //        },
        //        zoomType: this.modeManager.zoomType,
      },
      legend: {
        useHTML: true,
        align: 'left',
        verticalAlign: 'bottom',
        borderWidth: 0,
        enabled: true,
      },
      tooltip: {
        enabled: true,
        crosshairs: [false], //отключает линию по умолчанию
      },
    };
  }

  back() {
    router.push('/oil');
  }
}
